import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const DetailHeader = () => {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    const trimmed = query.trim();
    if (trimmed) navigate(`/search?search=${encodeURIComponent(trimmed)}`);
  };

  return (
    <header className="detail-header">
      <Link to="/" className="detail-header-logo" aria-label="Viewly home">VIEWLY</Link>
      <form className="detail-header-search" onSubmit={submit} role="search">
        <i className="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
        <input
          type="search"
          placeholder="Search movies and TV shows"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          aria-label="Search movies and TV shows"
          autoComplete="off"
        />
      </form>
    </header>
  );
};

export default DetailHeader;
